export default __webpack_public_path__ + "static/media/rocket_anim_33.bcf31f30.png";